import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
// @ts-ignore
import 'react-toastify/dist/ReactToastify.css';

import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

import Dashboard from './pages/dashboard/Dashboard';
import LoginPage from './pages/login/LoginPage';

import AppLayout from './layouts/AppLayout';
import BankDetailsForm from './pages/bank-details/BankDetailsForm';
import BankDetailsList from './pages/bank-details/BankDetailsList';
import CompanyForm from './pages/companies/CompanyForm';
import CompanyList from './pages/companies/CompanyList';
import CustomerForm from './pages/customers/CustomerForm';
import CustomerList from './pages/customers/CustomerList';
import InvoiceForm from './pages/invoices/InvoiceForm';
import InvoiceList from './pages/invoices/InvoiceList';
import ItemForm from './pages/items/ItemForm';
import ItemList from './pages/items/ItemList';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Protected + Layout */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          {/* ALL PAGES */}
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="companies" element={<CompanyList />} />
          <Route path="companies/new" element={<CompanyForm />} />
          <Route path="companies/:id/edit" element={<CompanyForm />} />

          <Route path="customers" element={<CustomerList />} />
          <Route path="customers/new" element={<CustomerForm />} />
          <Route path="customers/:id/edit" element={<CustomerForm />} />

          <Route path="items" element={<ItemList />} />
          <Route path="items/new" element={<ItemForm />} />
          <Route path="items/:id/edit" element={<ItemForm />} />

          <Route path="bank-details" element={<BankDetailsList />} />
          <Route path="bank-details/new" element={<BankDetailsForm />} />
          <Route path="bank-details/:id/edit" element={<BankDetailsForm />} />

          <Route path="invoices" element={<InvoiceList />} />
          <Route path="invoices/new" element={<InvoiceForm />} />
          <Route path="invoices/:id/edit" element={<InvoiceForm />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

export default App;
